import { UserProps, DATA_USER, get_user } from "./user";

export function ajax_get(url: string, callback: any) {
	var xmlhttp = new XMLHttpRequest();
	xmlhttp.onreadystatechange = function () {
		if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
			try {
				var data = JSON.parse(xmlhttp.responseText);
			} catch (err) {
				console.log(err.message + " in " + xmlhttp.responseText);
				return;
			}
			callback(data);
		}
	};

	xmlhttp.open("GET", url, true);
	xmlhttp.send();
}


export function youtube_parser(url: string) {
	var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
	var match = url.match(regExp);
	return (match && match[7].length == 11) ? match[7] : false;
};


export interface Detailprops {
	id: string;
	thumbnail: string;
	title: string;
	descript: string;
	user: UserProps;
	process: DetailProcessProps[];
	result: SourceProps[];
}

export interface DetailProcessProps extends SourceProps {
	note?: string;
}

export interface SourceProps {
	id: string;
	type: SourceType;
	value: string;
}

export enum SourceType {
	VIDEO = "video",
	IMAGE = "image"
}

export const DATA_DETAIL: Detailprops = {
	id: "0",
	user: DATA_USER,
	title: "someTitle",
	thumbnail: "https://images.unsplash.com/photo-1601994783933-f9d76b8cc447?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80",
	descript:
		"이상을 같은 인생을 무한한 꽃이 무엇을 크고 교향악이다. 청춘 착목한는 생명을 트고, 있는 봄바람이다. 앞이 충분히 그들의 실현에 미묘한 능히 과실이 위하여서 운다. 많이 현저하게 피는 구하지 끝까지 이상이 대고, 동산에는 사막이다. 대중을 따뜻한 역사를 바이며, 가지에 끓는다. 바로 피에 관현악이며, 속에 싶이 구할 끓는다. 용감하고 옷을 이상의 이상의 군영과 이것을 속에서 능히 유소년에게서 쓸쓸하랴? 위하여 놀이 원질이 어디 청춘의 가치를 그들의 사랑의 같지 끓는다. 영락과 평화스러운 그들은 열매를 위하여서. \n 웅대한 피가 기관과 이것은 사랑의 장식하는 일월과 기쁘며, 힘있다. 무한한 소리다.이것은 소담스러운 하였으며, 인생에 돋고, 밥을 맺어, 공자는 운다. 가진 굳세게 그와 보이는 같이, 이상은 얼마나 남는 있으랴? 못하다 유소년에게서 이상은 그들의 아니다. 수 바로 없으면, 목숨을 그림자는 때까지 말이다. 청춘의 주며, 것은 사막이다. 가치를 뭇 더운지라 가는 얼마나 피다. 두기 있음으로써 구하기 품에 사는가 살았으며, 사막이다. 하였으며, 영원히 귀는 실현에 그들의 할지라도 바이며, 이성은 사막이다. 이상, 이것을 그들의 소금이라 두기 그것을 커다란 사막이다. 얼마나 전인 풀이 남는 눈이 더운지라 싶이 불어 곳이 말이다.\n거선의 있는 바이며, 인류의 이상은 광야에서 예수는 심장은 보라. 속에 사랑의 타오르고 충분히 피가 것은 일월과 가는 약동하다. 별과 몸이 거친 없으면, 보배를 것이다. 사는가 고동을 얼마나 그들의 있으랴? 때까지 천하를 청춘 소리다.이것은 청춘을 교향악이다. 있을 청춘 같은 없는 아니다. 과실이 피고, 곧 아니더면, 약동하다. 보는 청춘 있는 것이다. 새 만물은 소담스러운 피가 품으며, 능히 것이다. 것은 위하여서 내는 인생을 주는 없는 피어나는 그러므로 것이다. 심장은 청춘의 뛰노는 봄바람을 힘차게 새가 봄바람이다.",
	process: [
		{
			id: "0",
			type: SourceType.IMAGE,
			value: "https://images.unsplash.com/photo-1601994783933-f9d76b8cc447?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80",
			note: "some text"
		},
		{
			id: "1",
			type: SourceType.VIDEO,
			value: "pj9cNnT7PJs",
			note: "some video text"
		},
		{
			id: "2",
			type: SourceType.VIDEO,
			value: "pj9cNnT7PJs"
		},
		{
			id: "3",
			type: SourceType.IMAGE,
			value: "https://images.unsplash.com/photo-1601994783933-f9d76b8cc447?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80"
		}
	],
	result: [
		{
			id: "0",
			type: SourceType.IMAGE,
			value: "https://images.unsplash.com/photo-1601994783933-f9d76b8cc447?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80"
		},
		{
			id: "1",
			type: SourceType.VIDEO,
			value: "pj9cNnT7PJs"
		}
	]
};


export function get_detail(data: any, id: string) {
	let acf = data.acf;

	let detail = {
		id: "",
		thumbnail: "",
		title: "",
		descript: "",
		process: [],
		result: [],
		user: get_user(data)
	};
	detail = Object.assign(detail, { id });
	detail = Object.assign(detail, { title: data.title.rendered });
	detail = Object.assign(detail, { user: get_user(data) });
	if (acf.thumbnail) detail = Object.assign(detail, { thumbnail: acf.thumbnail.url });
	if (acf.scenario) detail = Object.assign(detail, { descript: acf.scenario });
	if (acf.process) {
		let process = [];
		for (let j = 0; j < acf.process.length; j++) {
			let acf_part = acf.process[j];
			let part = {
				id: j + "",
				type: SourceType[acf_part.acf_fc_layout == "image" ? "IMAGE" : "VIDEO"],
				value: acf_part.acf_fc_layout == "image" ? acf_part.image.url : youtube_parser(acf_part.video)
			};
			if (acf_part.text != "") part = Object.assign(part, { note: acf_part.text });
			process.push(part);
		}
		detail = Object.assign(detail, { process });
	}
	if (acf.zplanet) {
		let zplanet = [];
		for (let j = 0; j < acf.zplanet.length; j++) {
			let acf_part = acf.zplanet[j];
			let part = {
				id: j + "",
				type: SourceType[acf_part.acf_fc_layout == "image" ? "IMAGE" : "VIDEO"],
				value: acf_part.acf_fc_layout == "image" ? acf_part.image.url : youtube_parser(acf_part.video)
			};
			if (acf_part.text != "") part = Object.assign(part, { note: acf_part.text });
			zplanet.push(part);
		}
		detail = Object.assign(detail, { result: zplanet });
	}
	return detail;

}